module.exports = __webpack_public_path__ + "./kit/docs/img/icon-constructor.a8c84aa3e6bf5f3ca77135613f6c5224.svg";